const routes = [
  {
    path: '/public/organization/:id',
    name: 'public-organization',
    component: () => import('./views/Organization/index.vue'),
    meta: {
      title: 'Профиль организации',
    },
  },
  {
    path: '/public/certificate/:id',
    name: 'public-certificate',
    component: () => import('./views/Certificate/index.vue'),
    meta: {
      title: 'Профиль пользователя',
    },
  },
  {
    path: '/public/expert/:id',
    name: 'public-expert',
    component: () => import('./views/ExpertView.vue'),
    title: 'Профиль эксперта',
  },
  {
    path: '/public/event-manager/:id',
    name: 'public-event-manager',
    component: () => import('./views/event-manager.vue'),
    meta: {
      title: 'Event-менеджер',
      layout: 'ui-design',
    },
  },
  {
    path: '/public/team/:id',
    component: () => import('./views/Team/index.vue'),
  },
];

export default routes;
